const contarSeparadores = (linea, separador) => {
	let cantidad = 0;
	let dentroDeComillas = false;

	for (let i = 0; i < linea.length; i++) {
		if (linea[i] === '"') {
			if (dentroDeComillas && linea[i + 1] === '"') {
				i++;
			} else {
				dentroDeComillas = !dentroDeComillas;
			}
		} else if (!dentroDeComillas && linea[i] === separador) {
			cantidad++;
		}
	}

	return cantidad;
};

export const prepararCsvParaExcel = (contenido) => {
	const contenidoSinBom = contenido.replace(/^\uFEFF/, '');
	const directivaExistente = contenidoSinBom.match(/^sep=(.)\r?\n/i);
	const primeraLinea = contenidoSinBom.split(/\r?\n/, 1)[0];
	const candidatos = [';', ','];
	const separador = directivaExistente
		? directivaExistente[1]
		: candidatos.reduce((seleccionado, candidato) =>
			contarSeparadores(primeraLinea, candidato) > contarSeparadores(primeraLinea, seleccionado)
				? candidato
				: seleccionado
		, candidatos[0]);

	if (contarSeparadores(primeraLinea, separador) === 0 && !directivaExistente) {
		return contenidoSinBom;
	}

	// Algunas descripciones contienen tabulaciones que Excel interpreta como
	// columnas. Se reemplazan por espacios cuando el CSV usa otro separador.
	const contenidoNormalizado = separador === '\t'
		? contenidoSinBom
		: contenidoSinBom.replace(/\t/g, ' ');

	return directivaExistente
		? contenidoNormalizado
		: `sep=${separador}\r\n${contenidoNormalizado}`;
};
